(() => {
  const config = document.getElementById('ComboSizeSync');
  const main = document.querySelector('product-info[data-section-type="main-product"]');
  if (!config || !main || !window.FoxThemeEvents) return;

  const { sizeIndex, initialSize } = JSON.parse(config.textContent);
  const selector = '.Avada-OfferItem.-fbt .Avada-VariantSelection__Trigger[aria-label^="Size:"]';
  const normalize = value => String(value || '').trim().toUpperCase();
  const attempted = new WeakMap();
  let size = normalize(initialSize);
  let revision = 0;
  let running = false;
  let scheduled = false;
  const pause = () => new Promise(resolve => setTimeout(resolve, 50));

  function notice(trigger, message) {
    const item = trigger.closest('.Avada-OfferItem');
    let warning = item.querySelector('[data-combo-size-warning]');
    if (!message) {
      warning?.remove();
      return;
    }
    if (!warning) {
      warning = document.createElement('p');
      warning.dataset.comboSizeWarning = '';
      warning.setAttribute('role', 'status');
      item.append(warning);
    }
    warning.textContent = message;
  }

  async function selectSize(trigger, expected, version) {
    if (normalize(trigger.getAttribute('aria-label').split(':').slice(1).join(':')) === expected) {
      notice(trigger, '');
      return;
    }
    if (trigger.getAttribute('aria-expanded') === 'true') return;

    // Use the app's keyboard and option handlers so its variant state is updated.
    trigger.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));
    let list;
    for (let count = 0; count < 20; count++) {
      await pause();
      if (!trigger.isConnected || version !== revision) break;
      list = document.getElementById(trigger.getAttribute('aria-controls'));
      if (list) break;
    }
    try {
      if (!trigger.isConnected || version !== revision) return;
      const option = Array.from(list?.querySelectorAll('[role="option"]') || []).find(
        node => normalize(node.textContent) === expected &&
          node.getAttribute('aria-disabled') !== 'true' && !node.hasAttribute('disabled')
      );
      if (option) {
        option.click();
        await pause();
      }
      const matched = normalize(trigger.getAttribute('aria-label').split(':').slice(1).join(':')) === expected;
      notice(trigger, matched ? '' : `Size ${expected} could not be selected. Please choose an available size for this combo item.`);
    } finally {
      if (trigger.isConnected && trigger.getAttribute('aria-expanded') === 'true') {
        trigger.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      }
    }
  }

  async function synchronize() {
    scheduled = false;
    if (running || !size) return;
    running = true;
    try {
      const version = revision;
      for (const trigger of main.querySelectorAll(selector)) {
        if (version !== revision) break;
        if (!trigger.isConnected || attempted.get(trigger) === version) continue;
        attempted.set(trigger, version);
        await selectSize(trigger, size, version);
      }
    } finally {
      running = false;
      if (Array.from(main.querySelectorAll(selector)).some(el => attempted.get(el) !== revision)) schedule();
    }
  }

  function schedule() {
    if (scheduled || running) return;
    scheduled = true;
    requestAnimationFrame(synchronize);
  }

  window.FoxThemeEvents.subscribe('variant-change', ({ data }) => {
    if (!data || data.sectionId !== (main.dataset.originalSection || main.dataset.section)) return;
    const nextSize = normalize(data.variant?.options?.[sizeIndex]);
    if (!nextSize || nextSize === size) return;
    size = nextSize;
    revision++;
    schedule();
  });

  // Observe delayed app mounts without repeatedly overriding manual selections.
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  main.addEventListener('click', event => {
    const button = event.target.closest('.Avada-Offer__ButtonAddToCart');
    const warning = button?.closest('.Avada-OfferLayout')?.querySelector('.Avada-OfferItem.isSelected [data-combo-size-warning]');
    if (warning) {
      event.preventDefault();
      event.stopImmediatePropagation();
      warning.scrollIntoView({ block: 'nearest' });
    }
  }, true);
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const option = event.target.closest('.Avada-VariantSelection__Option');
    const list = option?.closest('[role="listbox"]');
    if (!list) return;
    for (const trigger of main.querySelectorAll(selector)) {
      if (trigger.getAttribute('aria-controls') === list.id && option.getAttribute('aria-disabled') !== 'true') {
        notice(trigger, '');
      }
    }
  }, true);
  schedule();
})();
